<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { DropdownMenuSeparator as RekaDropdownMenuSeparator } from 'reka-ui'

import '../item.css'
</script>

<template>
  <RekaDropdownMenuSeparator class="flopui-menu-item-separator" />
</template>
